import Vue from 'vue';
import DEFINES from'@/defines'
/**
 * Filter screening and VOD events by is_vod_event flag
 */
Vue.filter ('EventType', function (items, type) {
  if (!items) return '';
  // Filter all standard events dynamically
  if(type == DEFINES.EVENT_TYPE.VOD_EVENTS) return items.filter (item => item.is_vod_event == true);

  // Filter all vod events dynamically
  if(type == DEFINES.EVENT_TYPE.STANDARD_EVENTS) return items.filter (item => item.is_vod_event == false);
});
